// API
import { useRequests } from "@api/requests";

// Types
import type { IntegrationsService } from "@application/ports";
import type { GetIntegrationsAPIResponse, ListAPIResponse } from "./integrations.types";

// Utils
import { ok } from "neverthrow";

export const useIntegrationsService = (): IntegrationsService => {
  const requestAPIV2 = useRequests();

  const ecommerceRadarService: IntegrationsService = {
    async list(params) {
      const res = await fetch(`/data/integrations-${params.lang}.json?_=${Date.now()}`, {
        method: "GET",
      });

      return ok((await res.json()) as unknown as ListAPIResponse);
    },
    async getIntegrations() {
      const res = await requestAPIV2<GetIntegrationsAPIResponse>({
        url: `/integrations`,
        method: "get",
      });

      return ok(res.data);
    },
  };

  return ecommerceRadarService;
};
